import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  standalone: true,
  selector: 'lib-contact-details-overlay',
  templateUrl: './contact-details-overlay.component.html',
  styleUrls: ['./contact-details-overlay.component.scss'],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContactDetailsOverlayComponent {
  @Input() isOverlayOpen = false;
  @Input() contactName = 'Sharath Kasa Reddi';
  @Input() contactEmail = 'info@shiploup.com';
  @Input() contactPhone = '1 (800) 303-4544';
  @Output() closingeOverlay = new EventEmitter<object>();

  closeOverlay() {
    this.isOverlayOpen = false;
    this.closingeOverlay.emit(null);
  }
}